import { z } from 'zod';
import {
    type ControlSocketKind,
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const pickLightChannelCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('pickLightChannel'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
    })),
}));
interface PickLightChannelCfgSchema extends z.infer<typeof pickLightChannelCfgSchema> {}

export const pickLightChannelSocketCfg = {
    controlSockets: {
        outputs: _cfg => {
            const ret: Partial<Record<'picked', ControlSocketKind>> = {
                picked: 'event',
            };
            return ret;
        },
        inputs: _cfg => {
            const ret: Partial<Record<'toggleTestLights' | 'resetLights' | 'toggleAddressingMode' | 'setOrientation', ControlSocketKind>> = {
                resetLights: 'event',
                setOrientation: 'event',
                toggleTestLights: 'event',
                toggleAddressingMode: 'event',
            };
            return ret;
        },
    },
    dataSockets: {
        outputs: _cfg => {
            const ret: Partial<Record<'pickedLightId' | 'pickedLightChannelNum', 'number'>> = {
                pickedLightId: 'number',
                pickedLightChannelNum: 'number',
            };
            return ret;
        },
        inputs: _cfg => {
            const ret: {
                orientation: 'string';
                channelNumber: 'number';
                addressingModeEndingId: 'number';
                addressingModeStartingId: 'number';
            } = {
                orientation: 'string',
                channelNumber: 'number',
                addressingModeEndingId: 'number',
                addressingModeStartingId: 'number',
            };
            return ret;
        },
    },
} satisfies NodeSocketCfg<PickLightChannelCfgSchema>;
